import { render, staticRenderFns } from "./Admin_Voice.vue?vue&type=template&id=0c45f256&scoped=true"
import script from "./Admin_Voice.vue?vue&type=script&lang=js"
export * from "./Admin_Voice.vue?vue&type=script&lang=js"
import style0 from "./Admin_Voice.vue?vue&type=style&index=0&id=0c45f256&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c45f256",
  null
  
)

export default component.exports